import {
  GET_ALL_USER_TRACTORS,
  GET_ALL_TRACTORS,
  GET_TRACTOR_PROFILE,
  HIRE_TRACTOR,
  GET_ALL_INVESTMENT_UNITS,
  GET_ALL_INVESTMENT_UNITS_ARR,
} from "../actions/action.types";

const initialState = {
  all: [],
  personal: [],
  request_tractor: {},
  profile: {},
};

const tractorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_TRACTORS:
      return {
        ...state,
        all: action.payload,
      };
    case GET_ALL_INVESTMENT_UNITS:
      return {
        ...state,
        allUnits: action.payload,
      };
    case GET_ALL_INVESTMENT_UNITS_ARR:
      return {
        ...state,
        allUnitsArr: action.payload,
      };
    case GET_ALL_USER_TRACTORS:
      return {
        ...state,
        personal: action.payload,
      };
    case GET_TRACTOR_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    case HIRE_TRACTOR:
      return {
        ...state,
        request_tractor: action.payload,
      };
    default:
      return state;
  }
};

export default tractorReducer;
